module.exports = __webpack_public_path__ + "img/img2.283233ea.jpg";